import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HpOidcClientModule } from '@upmc-healthplan-npm/oidc-client';

import { CoreModule } from './core/core.module';
import { MainModule } from './modules/main/main.module';
import { SearchModule } from './modules/search/search.module';
import { SearchDetailsModule } from './modules/searchdetails/search-details.module';

import { SharedComponentsModule } from './shared/shared-components.module';

import { MedicationModule } from './modules/medication/medication.module';
import { resolveServiceUrl, resolveOAuthConfig, resolveServicePCPUrl, resolveAzureMapClientID, resolveServiceProviderSiteMapAuthUrl, resolveServiceMemberUrl, resolveOcpApimSubscriptionKey, resolveApiKey, resolveApplicationInsights, resolveServiceConsumerProfileUrl, apiVersion, resolvePiwikConfig } from './environment-resolver';
import { SERVICE_URL, SERVICE_PCP_URL, SERVICE_MEMBER_URL, AZURE_MAP_CLIENT_ID, SERVICE_SUBSCRIPTION_KEY, SERVICE_PROVIDER_SITE_MAP_AUTH_URL, SERVICE_API_KEY, SERVICE_CONSUMER_PROFILE_URL, SERVICE_API_VERSION } from './tokens';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SignInRedirectComponent } from './components/sign-in-redirect/sign-in-redirect.component';
import { ProvidersInterceptor } from './core/interceptors/providers.interceptor';
import { AppInsightsModule } from './app-insights/app-insights.module';
import { NGX_PIWIK_PRO_INITIALIZER_PROVIDER, NGX_PIWIK_PRO_SETTINGS_TOKEN } from '@piwikpro/ngx-piwik-pro';

@NgModule({
  declarations: [
    AppComponent,
    SignInRedirectComponent
  ],
  imports: [
    MatButtonModule,
    MatListModule,
    MatSidenavModule,
    MatToolbarModule,
    MatMenuModule,
    MatDialogModule,
    AppRoutingModule,
    CoreModule,
    MainModule,
    SearchModule,
    SearchDetailsModule,
    MedicationModule,
    SharedComponentsModule,
    HpOidcClientModule.forRoot(resolveOAuthConfig),
    AppInsightsModule.forRoot(resolveApplicationInsights)
  ],
  providers: [
    {
      provide: SERVICE_URL,
      useFactory: resolveServiceUrl
    }, 
    {
      provide: NGX_PIWIK_PRO_SETTINGS_TOKEN,
      useFactory: resolvePiwikConfig
    },
    NGX_PIWIK_PRO_INITIALIZER_PROVIDER,
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: SERVICE_PCP_URL,
      useFactory: resolveServicePCPUrl
    },
    {
      provide: SERVICE_MEMBER_URL,
      useFactory: resolveServiceMemberUrl
    },
    {
      provide: SERVICE_SUBSCRIPTION_KEY,
      useFactory: resolveOcpApimSubscriptionKey
    },
    {
      provide: SERVICE_API_VERSION,
      useFactory: apiVersion
    },
    {
      provide: SERVICE_API_KEY,
      useFactory: resolveApiKey
    },
    {
      provide: SERVICE_CONSUMER_PROFILE_URL,
      useFactory: resolveServiceConsumerProfileUrl
    },
    {
      provide: SERVICE_PROVIDER_SITE_MAP_AUTH_URL,
      useFactory: resolveServiceProviderSiteMapAuthUrl
    },
    {
      provide: AZURE_MAP_CLIENT_ID,
      useFactory: resolveAzureMapClientID
    },
    ProvidersInterceptor
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

